module.exports = __webpack_public_path__ + "img/83.d8128d1f.jpg";